export function unwatch (x) {
  return JSON.parse(JSON.stringify(x))
}
